import {
	isAdminhubPolicyCreateAction,
	isAdminhubPolicyUpdateAction,
} from '@atlassian/conversation-assistant-action-helpers/utils/adminhub-actions';
import {
	isStoreAssistant,
	type StoreChatItem,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

const parsePolicyPreviewActionData = (rawData: unknown): Record<string, unknown> | null => {
	let data = rawData;
	if (typeof data === 'string') {
		try {
			data = JSON.parse(data) as unknown;
		} catch {
			return null;
		}
	}

	if (!data || typeof data !== 'object' || Array.isArray(data)) {
		return null;
	}

	if ('input' in data) {
		data = (data as { input?: unknown }).input;
		if (typeof data === 'string') {
			try {
				data = JSON.parse(data) as unknown;
			} catch {
				return null;
			}
		}
	}

	if (!data || typeof data !== 'object' || Array.isArray(data)) {
		return null;
	}

	return data as Record<string, unknown>;
};

export const getLatestPolicyPreviewContentId = (messages: StoreChatItem[]): string | undefined => {
	for (let messageIndex = messages.length - 1; messageIndex >= 0; messageIndex -= 1) {
		const message = messages[messageIndex];
		if (!isStoreAssistant(message)) {
			continue;
		}

		const actions = message.content.message.message.actions ?? [];
		for (let actionIndex = actions.length - 1; actionIndex >= 0; actionIndex -= 1) {
			const action = actions[actionIndex];
			if (!isAdminhubPolicyCreateAction(action) && !isAdminhubPolicyUpdateAction(action)) {
				continue;
			}

			const data = parsePolicyPreviewActionData(action.data);
			if (typeof data?.contentId === 'string' && data.contentId) {
				return data.contentId;
			}
		}
	}

	return undefined;
};
